import { render, staticRenderFns } from "./heighlights.vue?vue&type=template&id=7f959b89&"
import script from "./heighlights.vue?vue&type=script&lang=js&"
export * from "./heighlights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports